export default {
  // Navigation
  'nav.home': 'Home',
  'nav.solutions': 'Solutions',
  'nav.features': 'Features',
  'nav.pricing': 'Pricing',
  'nav.login': 'Login',
  'nav.getStarted': 'Get Started',
  
  // Hero Section
  'hero.title': 'Global Gaming Acceleration Platform',
  'hero.subtitle': 'Comprehensive Network Solutions for Overseas Game Publishers',
  'hero.description': 'Leveraging multi-node acceleration networks, dynamic traffic scheduling, and full-spectrum security protection to deliver integrated Download-Interaction-Protection network services',
  'hero.cta.primary': 'Start Free Trial',
  'hero.cta.secondary': 'View Demo',
  
  // Stats
  'stats.latency': 'Average Latency Reduction',
  'stats.conversion': 'Installation Conversion Increase',
  'stats.uptime': 'Service Uptime',
  'stats.nodes': 'Global Acceleration Nodes',
  
  // Solutions
  'solutions.title': 'Comprehensive Solutions',
  'solutions.subtitle': 'Addressing Three Core Pain Points in Global Gaming Operations',
  
  'solutions.download.title': 'Intelligent Download Acceleration',
  'solutions.download.desc': 'Multi-node CDN network ensures stable game package downloads in emerging markets, increasing installation conversion rates by 18%',
  'solutions.download.feature1': 'Breakpoint Resume Technology',
  'solutions.download.feature2': 'Intelligent Route Selection',
  'solutions.download.feature3': 'Multi-source Download',
  
  'solutions.interaction.title': 'Low-Latency Interaction',
  'solutions.interaction.desc': 'Millisecond-level latency optimization for cross-server battles and global tournaments, enhancing competitive gaming experience',
  'solutions.interaction.feature1': 'Dynamic Traffic Scheduling',
  'solutions.interaction.feature2': 'Protocol Optimization',
  'solutions.interaction.feature3': 'Real-time Monitoring',
  
  'solutions.security.title': 'Full-Spectrum Security Protection',
  'solutions.security.desc': 'Advanced DDoS and CC attack defense mechanisms, ensuring 99.99% server availability',
  'solutions.security.feature1': 'Intelligent Threat Detection',
  'solutions.security.feature2': 'Multi-layer Defense System',
  'solutions.security.feature3': '24/7 Security Monitoring',
  
  // Features
  'features.title': 'Platform Features',
  'features.subtitle': 'Powerful Capabilities Driving Your Global Gaming Success',
  
  'features.network.title': 'Global Acceleration Network',
  'features.network.desc': '500+ nodes across 6 continents, covering all major gaming markets',
  
  'features.analytics.title': 'Real-time Analytics Dashboard',
  'features.analytics.desc': 'Comprehensive data insights for network performance and user experience',
  
  'features.api.title': 'Developer-Friendly API',
  'features.api.desc': 'Easy integration with RESTful API and comprehensive documentation',
  
  'features.support.title': '24/7 Technical Support',
  'features.support.desc': 'Dedicated support team available around the clock',
  
  'features.scalability.title': 'Auto-Scaling Infrastructure',
  'features.scalability.desc': 'Automatically adjusts resources based on traffic demands',
  
  'features.compliance.title': 'Global Compliance',
  'features.compliance.desc': 'Meets data protection regulations across different regions',
  
  // Pricing
  'pricing.title': 'Flexible Pricing Plans',
  'pricing.subtitle': 'Choose the Perfect Plan for Your Gaming Business',
  
  'pricing.starter.name': 'Starter',
  'pricing.starter.price': '$299',
  'pricing.starter.period': '/month',
  'pricing.starter.desc': 'Perfect for indie game developers',
  'pricing.starter.feature1': 'Up to 100GB bandwidth',
  'pricing.starter.feature2': '50 acceleration nodes',
  'pricing.starter.feature3': 'Basic DDoS protection',
  'pricing.starter.feature4': 'Email support',
  'pricing.starter.feature5': 'API access',
  
  'pricing.professional.name': 'Professional',
  'pricing.professional.price': '$999',
  'pricing.professional.period': '/month',
  'pricing.professional.desc': 'Ideal for growing game studios',
  'pricing.professional.feature1': 'Up to 1TB bandwidth',
  'pricing.professional.feature2': '200 acceleration nodes',
  'pricing.professional.feature3': 'Advanced DDoS protection',
  'pricing.professional.feature4': 'Priority support',
  'pricing.professional.feature5': 'Custom analytics',
  'pricing.professional.feature6': 'Dedicated account manager',
  
  'pricing.enterprise.name': 'Enterprise',
  'pricing.enterprise.price': 'Custom',
  'pricing.enterprise.period': '',
  'pricing.enterprise.desc': 'For large-scale game publishers',
  'pricing.enterprise.feature1': 'Unlimited bandwidth',
  'pricing.enterprise.feature2': '500+ acceleration nodes',
  'pricing.enterprise.feature3': 'Enterprise-grade security',
  'pricing.enterprise.feature4': '24/7 dedicated support',
  'pricing.enterprise.feature5': 'Custom integration',
  'pricing.enterprise.feature6': 'SLA guarantee',
  'pricing.enterprise.feature7': 'White-label solution',
  
  'pricing.cta': 'Choose Plan',
  'pricing.popular': 'Most Popular',
  
  // CTA Section
  'cta.title': 'Ready to Accelerate Your Global Gaming Success?',
  'cta.description': 'Join hundreds of game publishers worldwide who trust Elephant Tech for their network infrastructure',
  'cta.button': 'Start Your Free Trial',
  
  // Footer
  'footer.product': 'Product',
  'footer.solutions': 'Solutions',
  'footer.features': 'Features',
  'footer.pricing': 'Pricing',
  'footer.documentation': 'Documentation',
  
  'footer.company': 'Company',
  'footer.about': 'About Us',
  'footer.careers': 'Careers',
  'footer.blog': 'Blog',
  'footer.press': 'Press Kit',
  
  'footer.resources': 'Resources',
  'footer.help': 'Help Center',
  'footer.api': 'API Reference',
  'footer.status': 'System Status',
  'footer.security': 'Security',
  
  'footer.legal': 'Legal',
  'footer.privacy': 'Privacy Policy',
  'footer.terms': 'Terms of Service',
  'footer.compliance': 'Compliance',
  
  'footer.copyright': '© 2024 Elephant Tech Limited. All rights reserved.',
  'footer.poweredBy': 'Powered by Readdy',
  
  // Login Page
  'login.title': 'Welcome Back',
  'login.subtitle': 'Sign in to your enterprise account',
  'login.email': 'Email Address',
  'login.password': 'Password',
  'login.remember': 'Remember me',
  'login.forgot': 'Forgot password?',
  'login.submit': 'Sign In',
  'login.noAccount': "Don't have an account?",
  'login.contact': 'Contact Sales',
  'login.or': 'Or continue with',
  'login.google': 'Google',
  'login.microsoft': 'Microsoft',
  'login.selectedPlan': 'Selected Plan',
};
